<template>
  <modal max-width="500px">
    <template #activator="props">
      <button
        @click="props.onClick()"
        class="
          px-4
          py-2
          ring-1 ring-gray-200
          rounded-md
          hover:bg-gray-200
          transform
          transition-transform
          duration-100
          hover:scale-105
        "
      >
        Заказать
      </button>
    </template>

    <template #default="{ close }">
      <order-card :close="close" :digital-driver-card="digitalDriverCard" />
    </template>
  </modal>
</template>

<script>
import { Modal } from "vue-neat-modal";
import OrderCard from "@/components/OrderCard";

export default {
  name: "OrderCardModal",
  props: {
    digitalDriverCard: Object,
  },
  components: {
    OrderCard,
    Modal,
  },
};
</script>

<style scoped></style>
